<template>
  <v-app>
    <v-main>
      <v-container class="terms-page py-8 py-md-12">
        <h1 class="text-h4 font-weight-bold mb-2">Terms of Service</h1>
        <p class="text-body-2 text-medium-emphasis mb-8">
          Last updated: September 2026
        </p>

        <section class="mb-6">
          <h2 class="text-h6 font-weight-bold mb-2">1. Who we are</h2>
          <p class="text-body-1">
            These terms govern the use of the LekoTech website, platform and
            applications (the "Services") provided by Lekotech sh.p.k.
          </p>
        </section>

        <section class="mb-6">
          <h2 class="text-h6 font-weight-bold mb-2">2. Use of the Services</h2>
          <p class="text-body-1">
            The platform is offered to businesses, such as vehicle dismantlers,
            under a separate agreement. You must provide accurate information,
            keep your login details confidential and use the Services only for
            lawful purposes.
          </p>
        </section>

        <section class="mb-6">
          <h2 class="text-h6 font-weight-bold mb-2">3. WhatsApp messaging</h2>
          <p class="text-body-1">
            Businesses may connect their WhatsApp Business number to LekoTech so
            that customer requests are answered through our platform, partly by
            an automated assistant. Each business is responsible for its
            conversations and must use WhatsApp in line with Meta's WhatsApp
            Business terms and policies. Customers writing to such a business
            can ask to speak with a person at any time.
          </p>
        </section>

        <section class="mb-6">
          <h2 class="text-h6 font-weight-bold mb-2">4. Parts and orders</h2>
          <p class="text-body-1">
            Spare-part information, prices and availability are provided by the
            business that owns the stock. Sales are concluded between the buyer
            and that business, or through the marketplace used (for example
            eBay), under their own conditions.
          </p>
        </section>

        <section class="mb-6">
          <h2 class="text-h6 font-weight-bold mb-2">
            5. Intellectual property
          </h2>
          <p class="text-body-1">
            The platform, software and website content belong to Lekotech
            sh.p.k. and may not be copied or reused without written permission.
          </p>
        </section>

        <section class="mb-6">
          <h2 class="text-h6 font-weight-bold mb-2">6. Liability</h2>
          <p class="text-body-1">
            We work to keep the Services available and accurate but cannot
            guarantee uninterrupted operation. To the extent allowed by law,
            Lekotech sh.p.k. is not liable for indirect losses arising from the
            use of the Services.
          </p>
        </section>

        <section class="mb-6">
          <h2 class="text-h6 font-weight-bold mb-2">7. Privacy</h2>
          <p class="text-body-1">
            Personal data is processed as described in our Privacy Policy:
            <a
              href="https://lekotech.com/privacy-policy/"
              target="_blank"
              rel="noopener noreferrer"
              >https://lekotech.com/privacy-policy/</a
            >
          </p>
        </section>

        <section class="mb-6">
          <h2 class="text-h6 font-weight-bold mb-2">8. Changes</h2>
          <p class="text-body-1">
            We may update these terms. The date at the top shows the latest
            version.
          </p>
        </section>

        <section class="mb-6">
          <h2 class="text-h6 font-weight-bold mb-2">9. Applicable law</h2>
          <p class="text-body-1">
            These terms are governed by the laws of Albania, without prejudice
            to mandatory consumer protection rules of your country.
          </p>
        </section>

        <p class="text-body-1">
          Contact:
          <a href="mailto:info@lekotech.com">info@lekotech.com</a>
        </p>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "Terms",
};
</script>

<style scoped>
.terms-page {
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}
</style>
